import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowPathOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M17.633 18c-.395 1.016-.914 1.887-1.565 2.564C15.099 21.572 13.792 22.2 12 22.2c-2.445 0-4.04-1.173-5.075-3.01C5.859 17.298 5.4 14.698 5.4 12v-.327L7.727 14 9 12.727l-4.5-4.5-4.5 4.5L1.273 14 3.6 11.673V12c0 2.852.478 5.802 1.756 8.073C6.666 22.398 8.82 24 12 24c2.272 0 4.05-.82 5.366-2.188 1-1.04 1.702-2.364 2.178-3.812z"
                    fill="currentColor"
                />
                <path
                    d="m19.5 15.773-4.5-4.5L16.273 10l2.327 2.327V12c0-2.698-.46-5.298-1.525-7.19C16.04 2.973 14.445 1.8 12 1.8c-1.775 0-3.073.616-4.037 1.604C7.297 4.085 6.768 4.968 6.367 6h-1.91c.48-1.467 1.196-2.808 2.218-3.854C7.986.803 9.752 0 12 0c3.18 0 5.334 1.602 6.643 3.927C19.922 6.197 20.4 9.147 20.4 12v.327L22.727 10 24 11.273z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ArrowPathOutlinedSize24Glyph.displayName = 'ArrowPathOutlinedSize24Glyph';
